import { apiFetch } from "./api";
import { getAuthHeaders } from "./auth";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8080";

export function recordTaskPageVisit(page) {
  const safePage = (page || "").trim();
  if (!safePage) {
    return Promise.resolve();
  }

  return apiFetch(
    `${API_BASE}/metrics/task-page?page=${encodeURIComponent(safePage)}`,
    {
      method: "POST",
      headers: {
        ...getAuthHeaders(),
      },
    }
  ).catch(() => undefined);
}
